import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { RolesMap } from '../../../helpers/constants';
import { colors } from '../WindowConfig';

export interface IRoleAssignementAreaProps {}

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
`;
const RoleCell = styled.div`
  min-width: 195px;
  height: 26px;
  display: flex;
  margin: 1px 0px;
  color: white;
`;
const RoleDisplay = styled.span`
  padding-left: 10px;
  text-transform: uppercase;
  flex-grow: 2;
  background-color: ${colors.secondary};
`;
const roles = [1, 5, 2, 6, 3, 7, 4];
const roleKey = [
  'mfccOne',
  'mfccFive',
  'mfccTwo',
  'mfccSix',
  'mfccThree',
  'mfccSeven',
  'mfccFour',
];

export default function RoleAssignementArea(props: IRoleAssignementAreaProps) {
  const s80 = useSelector((state: any) => state.executor.s80);
  const executor = useSelector((state: any) => state.executor);
  const lessonDef = useSelector(
    (state: any) => state.resources.lessonDefinition
  );
  const expandedRole = (roleStr: any): any =>
    roleStr ? RolesMap[roleStr.toUpperCase()] : '';
  return (
    <Container>
      {roles.map((role, index) => (
        <RoleCell key={`${role}`}>
          {lessonDef?.mfcc === roleKey[index] ? (
            <Cell index={role} role={expandedRole(executor.activeRole)}></Cell>
          ) : (
            <Cell
              index={role}
              role={expandedRole(s80.mfccRoles[roleKey[index]])}
            ></Cell>
          )}
        </RoleCell>
      ))}
    </Container>
  );
}

interface CellProps {
  index: number;
  role: string;
}

function Cell(props: CellProps) {
  const { index, role } = props;
  return (
    <React.Fragment>
      <span>{index}</span>
      <RoleDisplay>{role}</RoleDisplay>
    </React.Fragment>
  );
}
